function replaceLineBreaksToSpacesStringUtil (str) {
  if (!str) {
    return
  }
  return str.replace(/\n/g, ' ')
}

export {
  replaceLineBreaksToSpacesStringUtil
}
